import { YardPropertiesService } from './../../../yard-properties.service';
import { RegisterEntranceService } from './../../../components/visit-overview/dialog/register-entrance/service/register-entrance.service';
import { EntranceRegistration } from './../../../components/visit-overview/dialog/register-entrance/model/out/entrance-registration';
import { RegisterLeaveService } from './../../../components/visit-overview/dialog/register-leave/service/register-leave.service';
import { LeaveRegistration } from './../../../components/visit-overview/dialog/register-leave/model/out/leave-registration';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { CheckState } from './../../../components/visit-overview/dialog/register-leave/model/CheckState.enum';
import { TransportDetailLayout, TransportDetailMode } from './../../../common/configuration/transport.configuration';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppClientConfigurationService, AppServerAPI, ClientStatusService, DialogService, TranslationService } from '@sdbn/common';
import { EntranceLeaveTask, EntranceResult, OuthandedSupplementaryEquipment, RegisterEntranceLeaveData, SupplementaryEquipmentSelection, WeighingResult } from '../register-entrance-leave.model';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { Check } from '../../../components/visit-overview/dialog/register-entrance/model/Check';

@Component({
    selector: 'app-register-entrance-leave',
    templateUrl: './register-entrance-leave.component.html',
    styleUrls: ['./register-entrance-leave.component.scss'],
    standalone: false
})
export class RegisterEntranceLeaveComponent implements OnInit {

  registerEntranceForm = new FormGroup({
    registerArrival: new FormControl(false, [])
  });

  registerEntranceLeaveData: RegisterEntranceLeaveData;

  /* Constants & Enums */
  TMCClientParameters = TMCClientParameters;
  TransportDetailMode = TransportDetailMode;

  /* Layout properties */
  relevantReadOnlyLayout: TransportDetailLayout;
  titleDictionaryKey: string;
  confirmButtonDictionaryKey: string;
  declineButtonDictionaryKey: string;

  /* validity properties */
  supplementaryEquipmentValid: boolean = false;
  tasksValid: boolean = false;
  weighingValid: boolean = false;
  valid: boolean = false;

  /* data */
  weighingResult: WeighingResult;
  supplementaryEquipmentSelection: SupplementaryEquipmentSelection;
  acceptNonUniqueHandout = false;
  areaGateId: number;
  registerArrival = false;


  constructor(
    private dialogService: DialogService,
    public clientStatusService: ClientStatusService,
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<RegisterEntranceLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterEntranceLeaveData,
    public cps: AppClientConfigurationService,
    private appServerAPI: AppServerAPI,
    private leaveService: RegisterLeaveService,
    private entranceService: RegisterEntranceService,
    public yardPropertiesService: YardPropertiesService
  ) {

    this.registerEntranceLeaveData = data;
    console.log('entrance leave model', this.registerEntranceLeaveData);

    this.setLayoutProperties();
    this.updateTaskValidity();
    this.updateValidity();

  }

  ngOnInit(): void {

    this.registerEntranceForm.valueChanges.subscribe(value => {
      this.registerArrival = value.registerArrival;
      this.updateValidity();
    });

  }

  setLayoutProperties() {

    if (this.registerEntranceLeaveData.direction === 'entrance') {
      this.titleDictionaryKey = 'tmc-yard.access.ui.entrance-leave-dialog.title-entrance';
      this.confirmButtonDictionaryKey = 'tmc-yard.access.ui.entrance-leave-dialog.confirm-button-enter';
      this.declineButtonDictionaryKey = 'tmc-yard.access.ui.entrance-leave-dialog.decline-button-enter';
    } else {
      this.titleDictionaryKey = 'tmc-yard.access.ui.entrance-leave-dialog.title-leave';
      this.confirmButtonDictionaryKey = 'tmc-yard.access.ui.entrance-leave-dialog.confirm-button-leave';
      this.declineButtonDictionaryKey = 'tmc-yard.access.ui.entrance-leave-dialog.decline-button-leave';
    }

  }

  handleSupplementaryEquipmentChange(supplementaryEquipmentSelection: SupplementaryEquipmentSelection) {
    console.log('handleSupplementaryEquipmentChange', supplementaryEquipmentSelection);
    this.supplementaryEquipmentSelection = supplementaryEquipmentSelection;
  }

  handleSupplementaryEquipmentValidityChange(validity: boolean) {
    console.log('handleSupplementaryEquipmentValidityChange', validity);
    this.supplementaryEquipmentValid = validity;
    this.updateValidity();
  }

  handleGateSelectionChanged(selectedGate: number) {
    console.log('Gate selected', selectedGate);
    this.areaGateId = selectedGate;
  }

  private updateTaskValidity() {
    let valid = true;
    for (let task of this.registerEntranceLeaveData.tasks) {
      if (!task.done) {
        valid = false;
      }
    }
    this.tasksValid = valid;
  }

  private updateValidity() {

    let valid = true;

    /* Aufgaben */
    if (!this.tasksValid) {
      valid = false;
    }

    /* Begleitmittel */
    if (this.cps.isPropertyTrue(TMCClientParameters.FEATURES_COMBINED_ENTRANCE, false) && !this.supplementaryEquipmentValid) {
      valid = false;
    }

    /* Wiegung */
    if (this.yardPropertiesService.isWeighingLeaveEnabled() &&
      this.yardPropertiesService.isWeighingEnabled() && !this.weighingValid) {
      valid = false;
    }

    /* Prüfungen */
    for (let check of this.registerEntranceLeaveData.checks) {
      if (CheckState.FAILED === check.state) {
        if (check.key === 'PLANNED_STATE' && this.registerArrival) {
          /* valid state */
        } else {
          valid = false;
        }
      }
    }

    this.valid = valid;

  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public decline() {

    if (this.registerEntranceLeaveData.direction === 'entrance') {
      this.declineEntrance();
    } else {
      this.declineLeave();
    }

  }

  private declineEntrance() {

    const er = new EntranceRegistration();
    er.transportId = this.registerEntranceLeaveData.transport.id;

    this.entranceService.decline(er).subscribe(
      response => {
        this.dialogRef.close(false);
      }, error => {
        console.error(error);
      }
    );
  }


  private declineLeave() {

    const lr = new LeaveRegistration();
    lr.transportId = this.registerEntranceLeaveData.transport.id;
    lr.areaGateId = this.areaGateId;

    this.leaveService.decline(lr).subscribe(
      response => {
        this.dialogRef.close(false);
      }, error => {
        console.error(error);
      }
    );

  }

  public confirm() {

    if (this.registerEntranceLeaveData.direction === 'entrance') {
      this.confirmEntrance();
    } else {
      this.confirmLeave();
    }

  }

  private confirmEntrance() {

    this.appServerAPI.execute<EntranceResult>('/tmc-yard/access/entrance/confirmEntrance',
      {
        transportId: this.registerEntranceLeaveData.transport.id,
        weighingResult: this.weighingResult,
        supplementaryEquipmentSelection: this.supplementaryEquipmentSelection,
        acceptNonUniqueHandout: this.acceptNonUniqueHandout,
        areaGateId: this.areaGateId,
        registerArrivel: this.registerArrival
      }).subscribe(response => {

        if (response.nonUniqueSupplementaryEquipment) {


          let title = this.translationService.translate('tmc-yard.access.ui.entrance-leave-dialog.confirm-not-unique-equipment-title');
          let description = this.translationService.translate('tmc-yard.access.ui.entrance-leave-dialog.confirm-not-unique-equipment-description');

          description += '<br><br>[' + response.notes.join(', ') + ']';

          this.dialogService.showConfirmWithTitleAndMessage(title, description).afterClosed().subscribe(result => {

            if (result) {
              this.acceptNonUniqueHandout = true;
              this.confirm();
            }

          });

        } else {

          this.dialogRef.close(true);

        }

      }, error => {

        // TODO

      });

  }

  private confirmLeave() {

    this.appServerAPI.execute<EntranceResult>('/tmc-yard/access/leave/confirmLeave',
      {
        transportId: this.registerEntranceLeaveData.transport.id,
        weighingResult: this.weighingResult,
        outhandedSupplementaryEquipments: this.registerEntranceLeaveData.outhandedSupplementaryEquipments,
        acceptNonUniqueHandout: this.acceptNonUniqueHandout,
        areaGateId: this.areaGateId,
        registerArrivel: this.registerArrival
      }).subscribe(response => {

        this.dialogRef.close(true);

      }, error => {

        // TODO

      });

  }

  handleTasksChanged() {

    if (this.data.direction === 'entrance') {

      forkJoin(
        [
          this.entranceService.getTransport({ id: this.data.transport.id }),
          this.appServerAPI.execute<EntranceLeaveTask[]>('/tmc-yard/access/entrance/findTasksForEntrance', { id: this.data.transport.id })
        ]
      ).subscribe(results => {

        let checks = new Array<Check>;
        for (let check of results[0]?.checks) {
          checks.push(new Check(check));
        }
        this.data.checks = checks;

        let tasks = new Array<EntranceLeaveTask>();
        for (let task of results[1]) {
          tasks.push(new EntranceLeaveTask(task));
        }

        // sort
        tasks = tasks.sort((a, b) => a.id - b.id);
        this.data.tasks = tasks;

        this.updateTaskValidity();
        this.updateValidity();

      });

    } else if (this.data.direction === 'leave') {

      forkJoin(
        [
          this.leaveService.getTransport({ id: this.data.transport.id }),
          this.appServerAPI.execute<EntranceLeaveTask[]>('/tmc-yard/access/leave/findTasksForLeave', { id: this.data.transport.id })
        ]
      ).subscribe(results => {

        let checks = new Array<Check>;
        for (let check of results[0]?.checks) {
          checks.push(new Check(check));
        }
        this.data.checks = checks;

        let tasks = new Array<EntranceLeaveTask>();
        for (let task of results[1]) {
          tasks.push(new EntranceLeaveTask(task));
        }

        // sort
        tasks = tasks.sort((a, b) => a.id - b.id);
        this.data.tasks = tasks;

        this.updateTaskValidity();
        this.updateValidity();

      });



    }

    // let serviceURL = this.data.direction === 'entrance' ? '/tmc-yard/access/entrance/findTasksForEntrance' : '/tmc-yard/access/leave/findTasksForLeave';

    // this.appServerAPI.execute<EntranceLeaveTask[]>(serviceURL, { id: this.registerEntranceLeaveData.transport.id }).subscribe(response => {

    //   this.registerEntranceLeaveData.tasks = response;
    //   this.registerEntranceLeaveData.tasks = this.registerEntranceLeaveData.tasks.sort((a, b) => a.id - b.id);

    //   this.updateTaskValidity();
    //   this.updateValidity();

    // });

  }

  handleWeighingResult(weighingResult: WeighingResult) {
    this.weighingResult = weighingResult;
  }

  handleWeighingValidityChanged(validity: boolean) {
    this.weighingValid = validity;
    this.updateValidity();
  }

}
